import eventHandler from "./event-handler";


const CloseMessage = clickEl => {
	const message = clickEl.parentNode.parentNode;
	message.remove();
};

const hasJsCloseMessageClass = clickedEl => clickedEl.classList.contains("js-close-message");


const Initialise = () => {	
	eventHandler.attachClickEventHandlerToTheBody(hasJsCloseMessageClass, CloseMessage);
};

export default Initialise;
